import { z } from 'zod'
import { dateValueSchema } from './date-value'
import { recordListDataSchema } from './record-list-data'

/** 指派禮遇紀錄 Schema */
export const assignBenefitsRecordSchema = z.object({
  /** 指派者 */
  designee: z.string(),
  /** 指派日期 */
  assignTime: dateValueSchema,
  /** 收回禮遇者 */
  returner: z.string(),
  /** 收回禮遇日期 */
  returnTime: dateValueSchema,
  /** 歷程 */
  recordList: z.array(recordListDataSchema)
})

/** 指派禮遇紀錄 */
export interface AssignBenefitsRecord
  extends z.infer<typeof assignBenefitsRecordSchema> {}
